import axios from '@/mixins/axios/_defaultAxios'

export default axios.create({
  baseURL: process.env.VUE_APP_AUTH_SERVICE_URL
})